import React from 'react';

import useStyles from './styles';

function Footer() {
  const classes = useStyles();

  return <div className={classes.root} />;
}

export default Footer;
